import React, {useEffect, useState} from "react";
import Markdown from 'markdown-to-jsx';
import {Container} from 'reactstrap';
import {Spin} from "antd";

const readmePath = require("./Paradi_Privacy_Policy.md");

const style = {
    border:'1px solid #ddd',
    padding:'30px'
}

const PrivacyPolicy = () => {
    const [privacyPolicy, setPrivacyPolicyData] = useState("");
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        getPrivacyFile();
    }, [])

    const getPrivacyFile = async () => {
        try {
            setLoader(true);
            const data = await fetch(readmePath)
            const readMeData = await data.text();
            setPrivacyPolicyData(readMeData);
            setLoader(false);
        } catch (err) {
            setLoader(false);
            throw err;
        }
    }
    return (
        <Container className="privacy-policy" style={{...style}}>
            <Spin spinning={loader}>
                <Markdown>{privacyPolicy}</Markdown>
            </Spin>
        </Container>
    )
}

export {PrivacyPolicy}